import React from "react";
import Simple from "./Simple";
import Transaction from "./Transaction";

const Pricing = () => {
  return (
    <div>
      <Simple />
      <Transaction />
    </div>
  );
};

export default Pricing;
